import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-onenine-twozero',
  templateUrl: './onenine-twozero.component.html',
  styleUrls: ['./onenine-twozero.component.scss']
})
export class OnenineTwozeroComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
